import constant from "@/utils/constant";
import * as Sentry from "@sentry/react";
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from "react-router-dom";
import { useEffect } from "react";

Sentry.init({
    dsn: "https://f20839d64f6dfa5742cdf09903070114@o411916.ingest.us.sentry.io/4508676145807360",
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: constant.PROD || constant.STAGING,
    enableTracing: true,
    environment: constant.PROD ? "production" : "staging",
    ignoreErrors: ["$sentry-ignore"],
});
